/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
//constants

//css
import './AccountsHead.scss'
import { toAbsoluteUrl, KTSVG, camelCaseToNormalCase, defaultRegion } from '../../../../_metronic/helpers'
import { getAllUserDetails, fetchAsyncUserDetails } from './Overview/OverviewSlice/UserDetailsSlice'
import { getUserData } from '../../../modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'
import { AuthenticateUser } from '../../../Utils/_helpers/RoleAndPermission'
import { createFirstLetter } from '../../../Utils/_helpers'
import {
  useGetCountMessageQuery,
  useLazyGetCountMessageQuery,
  useLazyGetSubClientRemainingCreditQuery,
} from '../../../../services/cellcast.v2'
import { Spinner } from 'react-bootstrap'
import { GetSubClientShareCreditMode, SmppStatus } from '../../../../services/cellcast.v2.types'
import { toast } from 'react-toastify'
import { GetCurrentData } from '../../../Utils/_helpers/GetCurrentData'
import { useAccount } from './useAccount'

const AccountHeader: React.FC = () => {
  const currentUser = GetCurrentData();

  const location = useLocation()
  const dispatch = useDispatch()
  const userData: any = useSelector(getAllUserDetails)
  const isSmppServerActive = userData?.smppStatus && userData?.smppStatus === SmppStatus.Active

  const token: any = useSelector(getUserData)
  const creditsData = useSelector((state: any) => state?.userDetails?.userDetails?.data)
  let data = {
    refreshToken: token?.refreshToken,
    accessToken: token?.accessToken,
  }
  const [isShowCredit, setIsShowCredit] = useState(true)
  const [isShowReferral, setIsShowReferral] = useState(true)
  const [isSetCreditLimit, setIsShareCreditLimit] = useState(false)
  const [shareCreditRemain, setShareCreditRemain] = useState({
    type: '',
    sms: '-',
    mms: '-',
  })

  const { fetchBalanceHistory, isDefaultRegion } = useAccount();

  const { data: countMessage, isLoading: fetchCountMessageLoading } = useGetCountMessageQuery(null)
  const [getRemainCredit] = useLazyGetSubClientRemainingCreditQuery()

  useEffect(() => {
    dispatch(fetchAsyncUserDetails())
    // if (!userData) {
    //   dispatch(fetchAsyncRefreshToken(data))
    // }
  }, [])

  useEffect(() => {
    if (userData && userData.subClientAccountId && userData.subClientAccountId !== '') {
      if (userData._id !== userData.ownerId) {
        setIsShowCredit(false)

        if (userData.subClientLimitConfig) {
          if (
            userData.subClientLimitConfig.smsLimitPerDay > 0 ||
            userData.subClientLimitConfig.mmsLimitPerDay > 0 ||
            userData.subClientLimitConfig.smsLimitPerMonth > 0 ||
            userData.subClientLimitConfig.mmsLimitPerMonth > 0
          ) {
            setIsShareCreditLimit(true)
          }
        }
        setIsShowReferral(false)
      }
    }
  }, [userData])

  const getBalance = async () => {
    const res: any = await fetchBalanceHistory();
    if ('data' in res) {
      if (res.data && res.data?.data) {
        setShareCreditRemain({
          type: 'credits per day',
          sms: res.data.data.sms.toString(),
          mms: res.data.data.mms.toString(),
        })
      }
    } else if ('error' in res) {
      const errObj = res.error as any
      if (errObj.data.message) {
        toast.error(errObj.data.message)
      } else {
        toast.error(res.error)
      }
    }
  }
  useEffect(() => {
    if (isSetCreditLimit === true) {
      if (isDefaultRegion === false) {
        getBalance()
        return;
      }

      getRemainCredit(null)
        .then((res) => {
          if ('data' in res) {
            if (res.data && res.data.data) {
              setShareCreditRemain({
                type: res.data.data.mode === GetSubClientShareCreditMode.Day ? `/ day` : '/ month',
                sms: res.data.data.credit.sms.toString(),
                mms: res.data.data.credit.mms.toString(),
              })
            }
          } else if ('error' in res) {
            const errObj = res.error as any
            if (errObj.data.message) {
              toast.error(errObj.data.message)
            } else {
              toast.error(res.error)
            }
          }
        })
        .catch((err) => {
          toast.error(err.error)
        })
    }
  }, [isSetCreditLimit])

  const NavbarDefault = [
    { label: 'Overview', path: 'Overview', permission: 'all' },
    { label: 'Settings', path: 'Settings', permission: 'all' },
    { label: 'Billing', path: 'Billing', permission: 'create-auto-popup-setting' },
    { label: 'Referral', path: 'Referral', permission: 'all' },
    { label: 'Credit History', path: 'Balance History', permission: 'all' },
    { label: 'User List', path: 'Team List', permission: 'list-sub-accounts' },
    { label: 'Api keys', path: 'Api keys', permission: 'send-quick-sms' },
    { label: 'Smpp', path: 'smpp', permission: 'all' },
    { label: 'Notifications', path: 'Notifications', permission: 'see-notifications' },
  ]

  const NavbarRegion = [
    { label: 'Overview', path: 'Overview', permission: 'all' },
    { label: 'Settings', path: 'Settings', permission: 'all' },
    { label: 'Billing', path: 'Billing', permission: 'create-auto-popup-setting' },
    { label: 'Credit History', path: 'Balance History', permission: 'all' },
    { label: "Sender ID's", path: "Sender ID's", permission: 'show-dedicated-number' },
    { label: 'Api keys', path: 'Api keys', permission: 'send-quick-sms' },
  ]

  const Navbar = currentUser?.region === defaultRegion ? NavbarDefault : NavbarRegion;

  const SuperAdmin = ['Overview', 'Staff Account']
  const StaffAdmin = ['Overview', 'Settings', 'Staff Account']
  const User = ['Overview', 'Settings', 'Billing', 'Team List', 'Api keys']
  // const Navbar = user == 'superAdmin' ? SuperAdmin : user == 'staffAdmin' ? StaffAdmin : User
  // const listItems =

  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-body pt-9 pb-0'>
        <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
          <div className='me-7 mb-4'>
            <div className='symbol symbol-100px symbol-lg-160px symbol-fixed position-relative'>
              {userData?.avatar == '' || userData?.avatar == undefined || userData?.avatar == 'undefined' ? (
                <span
                  className='squere1'
                  style={{
                    width: '100px',
                    height: '100px',
                  }}
                >{`${userData?.firstName !== undefined && userData?.firstName !== ''
                  ? userData?.firstName?.split('')?.[0]?.toUpperCase() ?? 'C'
                  : createFirstLetter(userData?.name)?.firstName ?? 'C'
                  }${userData?.lastName !== undefined && userData?.lastName !== ''
                    ? userData?.lastName?.split('')?.[0]?.toUpperCase() ?? 'C'
                    : createFirstLetter(userData?.name).lastName ?? 'C'
                  }`}</span>
              ) : (
                <img src={userData?.avatar} alt='Cellcast' />
              )}
              <div
                className={`position-absolute translate-middle bottom-0 start-100 mb-6 rounded-circle border border-4 border-white h-20px w-20px ${userData?.status2 == 'active'
                  ? ' bg-success '
                  : userData?.status2 == 'inactive'
                    ? 'bg-secondary'
                    : 'bg-danger'
                  }`}
              ></div>
            </div>
          </div>

          <div className='flex-grow-1'>
            <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
              <div className='d-flex flex-column'>
                <div className='d-flex align-items-center mb-2'>
                  <span className='text-gray-800 fs-2 fw-bolder me-1'>{userData?.name}</span>
                  {userData?.status === 'verified' && (
                    <KTSVG
                      path='/media/icons/duotune/general/gen026.svg'
                      className='svg-icon-2 ms-1'
                    />
                  )}

                  {userData?.status === 'unverified' && (
                    <KTSVG
                      path='/media/icons/duotune/general/gen026.svg'
                      className='svg-icon-2 ms-1 svg-icon-success'
                    />
                  )}
                </div>

                <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2'>
                  <a
                    href='#'
                    className='d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2'
                  >
                    <KTSVG
                      path='/media/icons/duotune/communication/com006.svg'
                      className='svg-icon-4 me-1'
                    />
                    {camelCaseToNormalCase(userData?.role)}
                  </a>
                  <a
                    href='#'
                    className='d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2'
                  >
                    <KTSVG
                      path='/media/icons/duotune/general/gen018.svg'
                      className='svg-icon-4 me-1'
                    />
                    {userData?.isoCode === 'au' && 'Melbourne, Australia'}
                  </a>
                  <a
                    href='#'
                    className='d-flex align-items-center text-gray-400 text-hover-primary mb-2'
                  >
                    <KTSVG
                      path='/media/icons/duotune/communication/com011.svg'
                      className='svg-icon-4 me-1'
                    />
                    {userData?.email}
                  </a>
                </div>
              </div>
            </div>
            {location.pathname === '/accounts/overview' && (
              <div className='d-flex flex-wrap flex-stack account-stack'>
                <div className='d-flex flex-column flex-grow-1 pe-8'>
                  <div className='d-flex flex-wrap'>
                    <div className='border border-gray-300 border-solid rounded min-w-125px py-3 px-4 me-6 mb-3'>
                      <div className='d-flex align-items-center'>
                        <KTSVG
                          path='/media/mobile/mail-envelope.svg'
                          className='svg-icon-3 svg-icon-primary me-2'
                        />
                        {fetchCountMessageLoading ? (
                          <Spinner size='sm' />
                        ) : (
                          <div className='fs-2 fw-bolder'>{countMessage?.data || 0}</div>
                        )}
                      </div>

                      <div className='fw-bold fs-6 text-gray-400'>Message Sent</div>
                    </div>

                    <div className='border border-gray-300 border-solid rounded min-w-125px py-3 px-4 me-6 mb-3'>
                      <div className='d-flex align-items-center'>
                        <a
                          href='#'
                          className='svg-icon-1 me-2 fs-10 badge badge-light-success badge-square p-1'
                        >
                          SMS
                        </a>
                        <div className='fs-2 fw-bolder'>
                          {isShowCredit
                            ? creditsData?.credits?.sms
                            : `${shareCreditRemain.sms} ${shareCreditRemain.type}`}
                        </div>
                      </div>

                      <div className='fw-bold fs-6 text-gray-400'>SMS Credits</div>
                    </div>

                    <div className='border border-gray-300 border-solid rounded min-w-125px py-3 px-4 me-6 mb-3'>
                      <div className='d-flex align-items-center'>
                        <a
                          href='#'
                          className='svg-icon-1 me-2 fs-10 badge badge-light-info badge-square p-1'
                        >
                          MMS
                        </a>
                        <div className='fs-2 fw-bolder'>
                          {isShowCredit
                            ? creditsData?.credits?.mms
                            : `${shareCreditRemain.mms} ${shareCreditRemain.type}`}
                        </div>
                      </div>

                      <div className='fw-bold fs-6 text-gray-400'>MMS Credits</div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className='d-flex overflow-auto h-55px'>
          <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
            {Navbar.map((key: any, index: any) => {
              if (!AuthenticateUser(key?.permission) && key?.permission !== 'all') {
                return <div key={key.label}></div>
              }

              if (!isShowCredit && (key?.label === 'Billing')) {
                return <div key={key.label}></div>
              }

              if (!isShowReferral && key?.label === 'Referral') {
                return <div key={key.label}></div>
              }

              if (!isSmppServerActive && key?.label === 'Smpp') {
                return <div key={key.label}></div>
              }

              return (
                <li key={index?.toString()} className='nav-item'>
                  <Link
                    className={
                      `nav-link text-active-primary me-6 ` +
                      (location?.pathname ===
                        `/accounts/${key?.path?.toLowerCase().replace(/ /g, '-')}` && 'active')
                    }
                    to={`/accounts/${key?.path?.toLowerCase().replace(/ /g, '-')}`}
                  >
                    {key?.label == 'Api keys' ? key?.label?.toUpperCase() : key?.label}
                  </Link>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    </div>
  )
}

export { AccountHeader }
